import { yupResolver } from "@hookform/resolvers/yup";
import { ComponentsCustomer } from "@omni/types/components/customer/customer.model";
import { Button } from "@omni/ui/components/Button/button.component";
import { Fragment } from "react";
import { FormProvider } from "react-hook-form";
import * as yup from "yup";

import { BonusCardField } from "@/components/Form/RHF/FormFields/BonusCardField/bonusCardField.component";
import { OptionalBonusCardFieldSchema } from "@/components/Form/RHF/FormFields/BonusCardField/bonusCardField.schema";
import { useOmniForm } from "@/components/Form/RHF/Utils/useOmniForm";
import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import { Messages } from "@/components/General/Messages/messages.container";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { FormInfoProvider } from "@/utils/forms/formInfo.provider";

const FORM_ID = "bonusCardForm";

const AddBonusCardFormValidationSchema = OptionalBonusCardFieldSchema;

export type AddBonusCardFormValues = yup.InferType<
    typeof AddBonusCardFormValidationSchema
>;

type AddBonusCardFormProps = {
    title: string;
    text: string;
    customer: ComponentsCustomer;
    onSubmit: (values: AddBonusCardFormValues) => void;
    isLoading: boolean;
};

const AddBonusCardForm = ({
    title,
    text,
    customer,
    onSubmit,
    isLoading
}: AddBonusCardFormProps) => {
    const { t } = useGranite();

    const methods = useOmniForm({
        mode: "onBlur",
        reValidateMode: "onBlur",
        defaultValues: {
            bonusCardNumber: customer.bonusCardNumber || ""
        },
        resolver: yupResolver(AddBonusCardFormValidationSchema)
    });

    return (
        <Fragment>
            {title && <h4>{title}</h4>}
            {text && <div dangerouslySetInnerHTML={{ __html: text }} />}

            <Messages messageid={"bonuscard-feedback-failure"} />
            <Messages messageid={"bonuscard-feedback-success"} />
            <FormInfoProvider
                formId={FORM_ID}
                withNeverbounce={false}
            >
                {() => (
                    <FormProvider {...methods}>
                        <form
                            id={FORM_ID}
                            onSubmit={methods.handleSubmit(onSubmit)}
                        >
                            <Row>
                                <Col md={6}>
                                    <BonusCardField<AddBonusCardFormValues>
                                        label={t(
                                            "general.form.bonusCard.label"
                                        )}
                                        placeholder={t(
                                            "general.form.bonusCard.placeholder"
                                        )}
                                        required={false}
                                        eBonusCardNumber={
                                            customer.eBonusCardNumber
                                        }
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col
                                    xs={12}
                                    md={5}
                                    lg={4}
                                    className={"d-flex align-items-center mb-3"}
                                >
                                    <div className={"mt-md-3"}>
                                        <Button
                                            type="submit"
                                            size="md"
                                            color="primary"
                                            fullWidth
                                            loading={isLoading}
                                        >
                                            {t("account.bonusCard.add.button")}
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                        </form>
                    </FormProvider>
                )}
            </FormInfoProvider>
        </Fragment>
    );
};

export { AddBonusCardForm };
